import { useContext } from 'react';
import { AuthContext, AuthContextType } from '../providers/AuthProvider';

/**
 * Hook to access auth context
 * Must be used within AuthProvider
 */
export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

/**
 * Hook to check if user is authenticated
 */
export function useIsAuthenticated(): boolean {
  const { user, loading } = useAuth();
  return !loading && user !== null;
}

/**
 * Hook to check if user is superadmin
 */
export function useIsSuperadmin(): boolean {
  const { user } = useAuth();
  return user?.isSuperadmin ?? false;
}
